import * as React from 'react'
import { SVGProps } from 'react'
const SvgSquareSigma: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="square-sigma_svg__lucide square-sigma_svg__lucide-square-sigma-icon square-sigma_svg__lucide-square-sigma"
    {...props}>
    <rect width={18} height={18} x={3} y={3} rx={2} />
    <path d="M16 8.9V7H8l4 5-4 5h8v-1.9" />
  </svg>
)
export default SvgSquareSigma
